import { useContext } from 'react'

import { Form } from 'components/Form'
import { AmazonPageContext } from '../../contexts/AmazonPageContext'
import { useUpsertWorkspaceAmazon } from '../../hooks/useUpsertWorkspaceAmazon'
import { Schema, schema, schemaDefault } from './schema'
import { AmazonOnOffSection } from './sections/AmazonOnOffSection'
import { AmazonUamTamSection } from './sections/AmazonUamTamSection'

export const GeneralPageForm = () => {
  const { formId, setTouched, setValid, workspaceAmazon } = useContext(AmazonPageContext)

  const { errors: apiErrors, loading, upsert } = useUpsertWorkspaceAmazon()

  return (
    <Form<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={upsert}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(workspaceAmazon)}
    >
      {() => (
        <>
          <AmazonOnOffSection />
          <AmazonUamTamSection />
        </>
      )}
    </Form>
  )
}
